import { eventsSender, http } from 'globalState/global-state.js';

const addCarByNumber = function (number, callback, errorCallback) {
    eventsSender('car-api', 'getCarByNumber', { number });
    http.xmlUnsafeRequest
        .post('/garage/api/v1/addCarByRegNumber/', {
            number,
        })
        .then((response) => {
            if (response.data.success || response.data.redirect) {
                callback(response);
                eventsSender('car-api', 'carReceived', { service: 'autocod' });
            } else {
                errorCallback(response.data.msg);
                eventsSender('car-api', 'carNotReceived', {
                    service: 'autocod',
                });
            }
            eventsSender('car-api', 'responseReceived', { service: 'autocod' });
        })
        .catch((e) => {
            console.error(e.message);
            errorCallback(
                'Мы не смогли распознать ваш госномер, пожалуйста введите VIN'
            );
            eventsSender('car-api', 'serviceNotAvailable', {
                service: 'autocod',
            });
        });
};

const addCarByVin = function (vin, callback, errorCallback) {
    http.xmlUnsafeRequest
        .post('/garage/api/v1/addCarByVinCode/', {
            vin,
        })
        .then((response) => {
            if (response.data.success || response.data.redirect) {
                callback(response);
                eventsSender('car-api', 'carReceived', { service: 'vin' });
            } else {
                errorCallback(response.data.msg);
                eventsSender('car-api', 'carNotReceived', { service: 'vin' });
            }
        })
        .catch((e) => {
            console.error(e.message);
            eventsSender('car-api', 'serviceNotAvailable', { service: 'vin' });
        });

    eventsSender('car-api', 'getCarByVin', { vin: vin });
};

export { addCarByNumber, addCarByVin };
